import React from "react";
import { CalendarDay } from "../../calendar/utils";
import { LiturgyViewer } from "../../liturgy/LiturgyViewer";
import { getMattinsLiturgy } from "../../liturgy/mattins";
import { getPreviousDay } from "../../utils/date-utils";
import { useDataDependency } from "../../utils/RemoteDataProvider";
import {
    getEveningReadingsFromMorningReadings,
    LessonData,
    useSettings,
} from "../../utils/settings";
import { useTrackPray } from "../../utils/tracking";

export const Mattins: React.FC<{
    day: CalendarDay;
    isToday: boolean;
}> = (props) => {
    const { day, isToday } = props;

    console.log(day);

    const { settings, setSetting } = useSettings();

    useTrackPray(day, "mattins");

    const loadablePsalms = useDataDependency<string[]>({
        type: "proper psalms",
        day,
        psalmCycle: settings.psalmCycle,
        time: "morning",
    });

    const loadableLessons = useDataDependency<{
        firstLesson: LessonData;
        secondLesson: LessonData;
    }>({
        type: "mattins readings",
        day,
        mattinsReadings: settings.mattinsReadings,
        bibleTranslation: settings.bibleTranslation,
        refsOnly: false,
    });

    const loadablePreviousMattinsLessions = useDataDependency<{
        firstLesson: LessonData;
        secondLesson: LessonData;
    }>({
        type: "mattins readings",
        day: getPreviousDay(day),
        mattinsReadings: settings.mattinsReadings,
        bibleTranslation: settings.bibleTranslation,
        refsOnly: false,
    });

    const loadablePreviousEvensongLessions = useDataDependency<{
        firstLesson: LessonData;
        secondLesson: LessonData;
    }>({
        type: "evensong readings",
        day: getPreviousDay(day),
        evensongReadings: getEveningReadingsFromMorningReadings(
            settings.mattinsReadings
        ),
        bibleTranslation: settings.bibleTranslation,
        refsOnly: false,
    });

    return (
        <>
            <LiturgyViewer
                items={getMattinsLiturgy(
                    day,
                    settings,
                    loadablePsalms,
                    loadableLessons
                )}
            />
        </>
    );
};
